import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeSlug from 'rehype-slug';

type RaidTeam = 'heroic' | 'mythic' | null;

// Placeholder content – replace with your actual raid rules
const HEROIC_RULES = `  
**Lil’ Spoons**
**Raid Policies**  
**30 Jan 2026**

**Communication**

Discord is our primary source of notification for all relevant raid information. You are expected to read all the discord messages in the appropriate Lil Spoons channels and be up to date on the information throughout the week. 

We want to create a positive and fun raid environment, while also being efficient with the limited time we have together. Please limit voice conversations before and during boss encounters so the strategy can be reviewed in a timely manner. Important raid call outs, such as battle rez or bloodlust are at the sole discretion of the Raid Leader. If you are not asked to give special direction, please allow only the appointed people to do so. Chronic offenders of chatter / inappropriate call outs during prog may result in limited discord permissions. 

**Attendance**

Raiders are expected to be punctual. If you are going to be late or unable to attend, please let the Heroic Organizers or an Officer know as soon as possible. 

Do not start any activities (keys, delves, world quests, running the boston marathon, etc) if it will conflict with being on time for raid. **Making 19 people wait on you while you finish your key is unacceptable.**

**Loot** 

All questions and concerns regarding loot should be directed to Nelliel/Toph or other officer in raid 

***Tier Sets:***  
   
Players will not be eligible for tier tokens purely for ilvl upgrade until all heroic raiders have completed their 4-pc tier set.

***Normal / Heroic:*** 

Normal loot is free roll, with the exception of **tier tokens.** For the first three weeks of Heroic prog (or until all Little Spoons have 4-pc), **Normal** and **Heroic** tier tokens and rare trinkets are also prioritized for Heroic only raiders, regardless of ilvl. After three weeks, or until all Little Spoons have 4-pc, all loot is open. Please be considerate when rolling on Heroic items if you already have one from Normal, especially if it benefits someone’s main. Tl;dr: set completion for spoons \> ilvl upgrade for spoons \> tier token going to an alt

**Consumables**

The first season of the expansion is traditionally a season of high costs and low crafting capacity for the guild. Additionally, with the quality squish of consumables from 3 to 2 ranks, the effect bonus of rank 2 consumables is small but likely bought for a high premium. For this reason, consumable requirements are curtailed during normal progression, and quality requirements are reduced from earlier seasons in the interest of cost effectiveness for the guild and for raiders.

**Normal Progression:**  
Raiders will **not** be required to use consumables of any kind for Normal progression on a permanent basis. However, self-provisioning during this time is encouraged. 

If raid leadership determines that consumables are required for progressing a particular boss, the guild will  provide the following:

* Individual food for processing into hearty food. (all raiders should level Midnight cooking to 25 to do this)  
* Two rank 1 flasks as needed, or a rank 1 flask cauldron  
* One rank 1 potion cauldron  
* One rank 1 Vantus rune per week, distributed at raid leader discretion  
* W47CH D0G to extend raid buffs during breaks and extended discussions


Raiders are responsible for the following as needed:

* Additional flasks for the remainder of the raid night  
* Additional potions (including healing potions) for the remainder of the raid night


The following will not be required by raid leadership for Normal progression and are the sole prerogative of the raider:

* Gear Enchantments  
* Gems  
* Weapon Oils/Stones/Ammunition  
* Teas

**Heroic Progression:**  
Raiders will be required to use consumables starting in the first full night of Heroic progression until AOTC is achieved.

The guild will provide the following

* Hearty Feasts or individual food for processing into hearty food, as is deemed cost-optimised or efficient to satisfy the needs of multiple specs.   
* Two rank 1 flasks as needed or a rank 1 flask cauldron. This may be elevated to rank 2 in subsequent weeks.  
* One rank 1 potion cauldron. This may be elevated to rank 2 in subsequent weeks.  
* One rank 1 Vantus rune per week, distributed at raid leader discretion.  
* W47CH D0G to extend raid buffs during breaks and extended discussions

Raiders are responsible for the following:

* Additional flasks for the remainder of the raid night  
* Additional potions for the remainder of the raid night  
* Health potions  
* Weapon Oils/Stones/Ammunition  
* Augment runes will not be provided or required and are the sole prerogative of the raider

Raiders are primarily responsible for gemming and enchanting the following slots:

* All gem sockets filled, including at least 1 (rank 1 minimum) Thalassian Diamond.  
* Chest, Leg, Weapon and Ring enchants (rank 1 minimum). Other slots are enchantable with tertiary effects.  
* Gem and enchant requirements will be in force no later than the first night that Crown of the Cosmos, Belo’ren, or Midnight Falls progression is expected, or the first raid night after that progression starts.

Policy regarding Teas in Heroic progression will be discussed among raid organizers and officers if necessary, but are not forecasted to be required.

The guild bank will be stocked with a small number of items in the “Expensive” tab to gem and enchant your gear mid-raid, speak to an officer to access these items.

Guild repairs are set to 4,000 g per night on raid nights.

**Mechanics**

**Anyone in the group should be ready to fill in for assigned mechanics.** 

Certain group-wide CDs will be assigned by the raid lead. This includes things like darkness, rallying cry, stampeding roar, etc.

**Gear Requirement:**

All participants of Little Spoons raid **must be within 7 ilvl below the raids combined average ilvl.** For example, if the overall raid item level is 200 you must be at least 193 ilvl to be eligible to raid. Average item level will be measured at the end of raid, and will be the standard for the following week. 

**Attitudes**

*We aren’t a world-first server-top guild. We are a Once-a-week raiding guild that wants to push Heroic at a reasonable pace.*

***Don’t be a Dick \-*** Being a dick IS NOT someone giving you feedback, suggestions or correcting you. Being a dick IS talking down/belittling people, being toxic, being a brat...etc.

***Morale \-*** Bad moods spread like wildfire. If you are in a piss-poor attitude and raiding with your friends isn’t going to help, sit it out, relax and come back next week.

***Shennanigans*** **\-** We enjoy our fun, but read the room.  Progging a new boss or repeated wipes on bosses that should be farm is the wrong time to mess with your fellow raiders.  If you’re using a player manipulating ability on CD, you’re using it too much.

**Mythic Raiders & Alts:** There are mythic alts interested in joining the Lil’ Spoons, so please treat them as part of the team. While this is an AOTC only progression focused team, we’re all part of the same guild and will *all* abide by the rules and standards aforementioned in this document. The raid should be a healthy, fun space where everyone feels welcome to express themselves and play as one team.

**The officers are always open to your feedback and concerns**. The goal is simply to keep raids running smoothly and take a bit of unneeded stress off of officers during raids. This lets them focus on leading and not mediation or replying to people. If you have a serious concern please reach out to an officer to arrange a one-on-one conversation.
`;

const MYTHIC_RULES = `
**Mythic Team**
**Raid Policies**  
**30 Jan 2026**

**Communication**

Discord is our primary source of notification for all relevant raid information. You are expected to read all the discord messages in the appropriate boss channels and be up to date on the information throughout the week. 

We want to create a positive and fun raid environment, while also being efficient with the limited time we have together. Please limit voice conversations before and during boss encounters so the strategy can be reviewed in a timely manner. Important raid call outs, such as battle rez or bloodlust are at the sole discretion of the Raid Leader. If you are not asked to give special direction, please allow only the appointed people to do so. Chronic offenders of chatter / inappropriate call outs during prog may result in limited discord permissions. 

**Attendance**

Raiders are expected to be punctual. If you are going to be late or unable to attend raid, please let the officers know as soon as possible. 

Invites will start going out 20-30 minutes before the raid start time. Be online and in the raid 10 minutes prior so that the raid leader can make adjustments to the roster if necessary. During this 10 minute window, if you’re available please assist in killing trash so we can pull the boss promptly at 7:30. If we have not heard from you and you are not online 10 minutes prior, substitutions will be made to support an on time raid.

Do not start any activities (keys, delves, world quests, running the boston marathon, etc) if it will conflict with being on time for raid. **Making 19 people wait on you while you finish your key is unacceptable.**

**Loot** 

All questions and concerns regarding loot should be directed to Jtown (Johnnystepp)

***Tier Sets:***

Tier tokens dropped from bosses will have their own priority on top of loot rolls. A character rolling on tier tokens will have priority on them if that tier token will complete a 2-set or 4-set bonus when rolling for an upgrade. Players will not be eligible for tier tokens purely for ilvl upgrade until all raiders have completed their 4-pc tier set.

***Normal / Heroic:*** 

All normal loot is free roll. Heroic tier tokens and trinkets will be rewarded by the loot council. All other items will be free roll. If you already received an item on Normal difficulty, please be considerate of your fellow raiders when rolling on the Heroic version.

***Mythic:***

**\*\*All raiders must have RCLootCouncil AddOn. No Exceptions.\*\***

Players must pass on all loot. Players who do not pass on loot rolls may be subject to immediate removal and suspension from raiding.The raid will be utilizing a master looter (Jtown) to handle all loot rolls fairly. This ensures people aren’t needing on gear that isn’t an upgrade for them.

Everyone will have a loot sheet on WoWAudit. This sheet should be maintained and updated regularly so that it’s current before raid begins. If your loot sheet is not up to date, or empty, we will assume you don’t need any loot from raid. 

BoEs acquired by raiders are theirs to keep. Please consider contributing a small donation to the guild bank upon sale of your BoE.

**Consumables**

Raiders will be required to use the following buffs as directed.

The guild provides the following:

* Hearty Feasts  
* One Flask Cauldron per raid night (2 flasks per raider)  
* One Potion Cauldron per raid night (20 potions per raider)  
* One Vantus toon per week, distributed at raid leader discretion  
* Pausing Pylons to extend raid buffs during breaks and extended discussions


Raiders are responsible for the following:

* Additional flasks for the remainder of the raid night  
* Additional potions (including healing potions) for the remainder of the raid night  
* Gear Enchantments  
* Gems  
* Weapon Oils/Stones


The guild bank has a generous supply of the following in the “Mythic Raid” tab for your use:

* Invis Pots (r2)  
* Mana pots (r2)  
* Health pots (r2)  
* Weapon oils (r3)  
* Combat Potion (r3)  
* All flasks (r2)  
* Personal food (highest main stat and/or secondary stat)  
* *The feasts and pausing pylons in this tab are meant for use by raid leadership*

The guild bank also has a number of items in the “Expensive” tab to gem and enchant your gear mid-raid, speak to an officer to access these items:

* Gear enchants  
* Rank 3 Eversong Diamond and single-stat gems  
* *This list is subject to change*

Guild repairs are set to 4,000 g per night on raid nights.

**Mechanics**

**Anyone in the group should be ready to fill in for assigned mechanics.** 

Healers, it's your responsibility to know where to plan your healing CDs for an encounter. Check WoWUtils for our healing plan\!

Certain group-wide CDs will be assigned by the raid lead. This includes things like darkness, rallying cry, stampeding roar, etc. If assigned, please follow the MRT notes for these CDs.

**M+ / Great Vault**

* Minimum of 4x M+ dungeons on the highest loot drops you can get per week for the vault (+10 and up)  
* At the start of the season, we want to see full vaults from everyone to include the delve row (Tier 8 or higher)  
* You do not need to “push”, just do the minimum viable key to get the gear

**Attitudes**

*We aren’t a world-first server-top guild. We are a twice-a-week raiding guild that wants to push content as high as possible.*

***Don’t be a Dick \-*** Being a dick IS NOT someone giving you feedback, suggestions or correcting you. Being a dick IS talking down/belittling people, being toxic, being a brat...etc.

***Morale \-*** Bad moods spread like wildfire. If you are in a piss-poor attitude and raiding with your friends isn’t going to help, sit it out, relax and come back next week.

***Shennanigans*** **\-** We enjoy our fun, but read the room.  Progging a new boss or repeated wipes on bosses that should be farm is the wrong time to mess with your fellow raiders.  If you’re using a player manipulating ability on CD, you’re using it too much.

**The above does not mean officers do not need your input or want feedback**. This is simply to keep raids running smoothly and take a bit of unneeded stress off of raid officers during raids. This lets them focus on leading and not mediation or replying to people. If you have a serious concern please reach out to an officer to arrange a one-on-one conversation.`;

const RaidPolicies: React.FC = () => {
  const [selectedTeam, setSelectedTeam] = useState<RaidTeam>(null);

  return (
    <div className="page-container">
      <div className="max-w-5xl mx-auto px-4 pb-12">
      <h1 className="text-4xl md:text-5xl font-bold mb-8 text-center">
        <span className="gradient-text">Raid Policies</span>
      </h1>
      <p className="text-center text-text-secondary mb-8 max-w-2xl mx-auto">
        Expectations and policies for our raid teams. Choose a team below to view the corresponding document.
      </p>

      {/* Team selection – same pattern as M+ season selector */}
      <div className="flex flex-col items-center gap-4 mb-8">
        <div className="flex flex-wrap justify-center gap-2">
          <span className="text-sm text-gray-500 self-center mr-2">Select team:</span>
          <div className="flex rounded-lg overflow-hidden">
            <button
              onClick={() => setSelectedTeam('heroic')}
              className={`px-4 py-2 text-sm font-semibold transition-all duration-200 ${
                selectedTeam === 'heroic' ? 'bg-cyan-400 text-black' : 'bg-gray-800 text-white hover:bg-gray-700'
              }`}
            >
              Heroic Team
            </button>
            <button
              onClick={() => setSelectedTeam('mythic')}
              className={`px-4 py-2 text-sm font-semibold transition-all duration-200 ${
                selectedTeam === 'mythic' ? 'bg-cyan-400 text-black' : 'bg-gray-800 text-white hover:bg-gray-700'
              }`}
            >
              Mythic Team
            </button>
          </div>
        </div>
      </div>

      {/* Placeholder until a team is selected */}
      {selectedTeam === null ? (
        <div className="text-center py-16 px-4 rounded-xl bg-surface border border-border">
          <p className="text-xl text-text-secondary">
            Choose <strong className="text-cyan-300">Heroic Team</strong> or <strong className="text-cyan-300">Mythic Team</strong> above to view that team’s rules and expectations.
          </p>
        </div>
      ) : (
        <div className="rounded-xl bg-surface border border-border overflow-hidden">
          <div className="p-6 sm:p-8">
            <div className="raid-policies-markdown prose prose-invert prose-cyan max-w-none">
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeSlug]}
              >
                {selectedTeam === 'heroic' ? HEROIC_RULES : MYTHIC_RULES}
              </ReactMarkdown>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .raid-policies-markdown h1 { font-size: 1.75rem; margin-top: 0; margin-bottom: 1rem; }
        .raid-policies-markdown h2 { font-size: 1.25rem; margin-top: 1.5rem; margin-bottom: 0.75rem; }
        .raid-policies-markdown p { margin-bottom: 0.75rem; color: var(--text-secondary, #94a3b8); }
        .raid-policies-markdown ul { margin: 0.75rem 0; padding-left: 1.5rem; list-style-type: disc; list-style-position: outside; }
        .raid-policies-markdown li { margin-bottom: 0.25rem; display: list-item; }
        .raid-policies-markdown ol { margin: 0.75rem 0; padding-left: 1.5rem; list-style-type: decimal; list-style-position: outside; }
        .raid-policies-markdown ol li { display: list-item; }
        .raid-policies-markdown strong { color: #e2e8f0; }
        .raid-policies-markdown hr { border-color: rgba(34, 211, 238, 0.3); margin: 1.5rem 0; }
      `}</style>
      </div>
    </div>
  );
};

export default RaidPolicies;
